import { AbstractCommand } from 'src/models/command';

class DeleteRepetitionAppointmentWithMembers extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_DeleteRepetitionAppointmentWithMembers';
	readonly processId = 'random';

	public constructor(appointmentId: number) {
		super();

		this.parameters = {
			appointmentId: appointmentId,
		};
	}
}

export { DeleteRepetitionAppointmentWithMembers };
